module.exports = {
    API_TITLE:"科在研知识服务平台", //项目名称
    testdomainName:"https://api.kezaiyan.com/", //测试域名
    domainName:"https://api.kezaiyan.com/", //正式域名
    interfacePrefix:"", //接口前缀
    port:8060, //本地端口
    assetsPublicPath:"/", //打包后服务器文件路径
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 34